import { AutoAwesome } from "@mui/icons-material"
import { IconButton } from "../../basics/IconButton"

interface IContextButtonProps {
    onClick?: () => void
}

/**
 * Standard "open the assistant with this context" action used inside content cards.
 *
 * Uses the filled primary variant so it reads as a single, recognizable action and
 * is clearly distinct from the plain buttons that also live inside the cards
 * (e.g. the clean delete icon and the outlined "Ver Clientes" button).
 * Rendered at the same size everywhere it appears.
 */
const ContextButton = ({ onClick }: IContextButtonProps) => (
    <IconButton variant="filled" color="primary" onClick={onClick}>
        <AutoAwesome sx={{ fontSize: 18 }} />
    </IconButton>
)

export { ContextButton }
export type { IContextButtonProps }
